import { DesignTokenSizeEnum, Layout } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import { SelectCollectionDeliveryPageViewProps } from './SelectCollectionDeliveryPageViewProps';
import { SelectCollectionDeliveryPageFormSchema } from './SelectCollectionDeliveryPageFormSchema';
import { Form } from '../../modules/forms/Form';
import { CheckboxField } from '../../modules/forms/fields/CheckboxField';

export function SelectCollectionDeliveryPageVwView({ initialFormData, formRef }: SelectCollectionDeliveryPageViewProps): ReactElement {
  return (
    <Form schema={SelectCollectionDeliveryPageFormSchema} defaultValues={initialFormData} ref={formRef}>
      <Layout rowGap={DesignTokenSizeEnum.static350} allowOverflowingContent>
        <CheckboxField
          name="dropOffRequested"
          label="Do you need to be dropped off?"
          rules={{ required: true }}
        />
        <CheckboxField
          name="collectionRequested"
          label="Do you need to be collected?"
          rules={{ required: true }}
        />
      </Layout>
    </Form>
  );
}
